import { render, staticRenderFns } from "./AdvertComp.vue?vue&type=template&id=2159bc26&scoped=true"
import script from "./AdvertComp.vue?vue&type=script&lang=js"
export * from "./AdvertComp.vue?vue&type=script&lang=js"
import style0 from "./AdvertComp.vue?vue&type=style&index=0&id=2159bc26&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2159bc26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/qhygcg-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2159bc26')) {
      api.createRecord('2159bc26', component.options)
    } else {
      api.reload('2159bc26', component.options)
    }
    module.hot.accept("./AdvertComp.vue?vue&type=template&id=2159bc26&scoped=true", function () {
      api.rerender('2159bc26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/components/AdvertComp.vue"
export default component.exports